import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Paginated } from '../../models/paginated.model';
import { OutOfOfficeOverviewDelegation, OutOfOfficeOverviewQuery } from '../models/out-of-office-overview.model';

export type { OutOfOfficeOverviewDelegation, OutOfOfficeOverviewQuery };

/**
 * API service for managing team-wide out-of-office delegations.
 *
 * This service intentionally avoids state-management coupling (e.g. NGXS)
 * so components can call it directly and own their local UI state.
 */
@Injectable({
    providedIn: 'root'
})
export class OutOfOfficeOverviewService {
    private readonly httpClient = inject(HttpClient);
    private readonly delegationsBaseUrl = `${environment.apiUrl}/out-of-office/delegations`;

    /**
     * Loads team delegations within the provided UTC date range.
     */
    public getDelegations(query: OutOfOfficeOverviewQuery): Observable<Paginated<OutOfOfficeOverviewDelegation>> {
        let params = new HttpParams().append('startDate', query.startDate).append('endDate', query.endDate);

        if (query.teamIds) {
            params = params.append('teamIds', query.teamIds);
        }

        return this.httpClient.get<Paginated<OutOfOfficeOverviewDelegation>>(this.delegationsBaseUrl, { params });
    }

    /**
     * Deletes an existing delegation.
     */
    public deleteDelegation(delegationId: string): Observable<void> {
        return this.httpClient.delete<void>(`${this.delegationsBaseUrl}/${delegationId}`);
    }
}
